/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import './TopLevelAddButton.styles.scss';

import ClickableIcon from '../../components/ClickableIcon';

import RouteNames from '../RouteNames';
import { IconAddHE, IconAddNote } from '../../components/addIcons';
import { AddFileButton } from '../../components/modal/addMenu/AddFileButton';
import { navigate } from '../redux/NavigationActions';
import { TrackEvent } from '../../../utilities/UserMetrics';
import ShareCardMenu from '../../components/modal/ShareCardMenu';
import AddMenuHealthEntries from '../../components/modal/addMenu/AddMenuHealthEntries';
import { AddMenuMobileFiles } from '../../components/modal/addMenu/AddMenuMobileFiles';
import { useUIState } from '../../hooks/useUIState';

interface Props extends RouteComponentProps<{}> {
  dispatch(c): void;
}

const TopLevelAddButton = (props) => {
  return (
    <div className="cmp-topleveladdbutton">
      {props.children}
    </div>
  );
};

export const MyBackpackTopLevelAddButton = () => {
  const [, uiActions] = useUIState();

  return (
    <TopLevelAddButton>
      <Switch>
        <Route path={RouteNames.myBackpackNotes()}>
          <ClickableIcon onClick={() => { navigate(RouteNames.addNote()); }}>
            <IconAddNote />
          </ClickableIcon>
        </Route>

        <Route path={RouteNames.myBackpackFiles()}>
          <ClickableIcon onClick={() => {}}>
            <AddFileButton
              openMobileModal={() => {
                uiActions.pushDarkBigBlur(
                  <AddMenuMobileFiles
                    successRoute={RouteNames.fileUpload()}
                    onCancel={() => {
                      uiActions.dismissAllModals();
                    }}
                  />,
                );
              }}
            />
          </ClickableIcon>
        </Route>

        <Route>
          <ClickableIcon
            onClick={() => {
              uiActions.pushDarkBigBlur(<AddMenuHealthEntries />);
            }}
          >
            <IconAddHE />
          </ClickableIcon>
        </Route>
      </Switch>
    </TopLevelAddButton>
  );
};

export const MyGroupTopLevelAddButton = () => {
  return (
    <TopLevelAddButton>
      <ClickableIcon
        onClick={() => {
          TrackEvent.groups.searchStarted();
          navigate(RouteNames.findGroup());
        }}
      >
        <IconAddHE />
      </ClickableIcon>
    </TopLevelAddButton>
  );
};

export const MyContactsTopLevelAddButton = () => {
  return (
    <TopLevelAddButton>
      <ClickableIcon
        onClick={() => {
          navigate(RouteNames.contactAdd());
        }}
      >
        <IconAddHE />
      </ClickableIcon>
    </TopLevelAddButton>
  );
};

export const MyShareCardsTopLevelAddButton = () => {
  const [, uiActions] = useUIState();
  return (
    <TopLevelAddButton>
      <ClickableIcon
        onClick={() => {
          uiActions.pushDarkBigBlur(<ShareCardMenu />);
        }}
      >
        <IconAddHE />
      </ClickableIcon>
    </TopLevelAddButton>
  );
};

const TopLevelAddButtons = {
  MyBackpack: withRouter(MyBackpackTopLevelAddButton),
  MyGroup: MyGroupTopLevelAddButton,
  MyContacts: MyContactsTopLevelAddButton,
  MyShareCards: MyShareCardsTopLevelAddButton,
};

export default TopLevelAddButtons;
